<!--suppress AngularInvalidExpressionResultType -->
<ngx-spinner
  type="main-spinner"
  template="<img src='/assets/gif/spinner.gif' width='400'>"
>
</ngx-spinner>

<app-sidenav> </app-sidenav>
